import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import MarketingEmailModel from '../models/MarketingEmailModel';
import Utility from '../../../app/utility';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface MarketingEmailSearchState {
    marketingEmailSearchResults: MarketingEmailModel[],
    triggerSearch: number,
    searchResultTotalRecord: number,
    orderBy: string,
    orderDirection: OrderDirection,
    searchSubject: string,
}

const initialState: MarketingEmailSearchState = {
    marketingEmailSearchResults: [],
    triggerSearch: new Date().getTime(),
    searchResultTotalRecord: 0,
    orderBy: Utility.propertyOf<MarketingEmailModel>("updatedDate"),
    orderDirection: OrderDirection.Desc,
    searchSubject: "",
}

export const MarketingEmailSearchSlice = createSlice({
    name: "MarketingEmailSearch",
    initialState,
    reducers: {
        setMarketingEmailSearchResults: (state, action: PayloadAction<MarketingEmailModel[]>) => {
            state.marketingEmailSearchResults = action.payload;
        },
        setTriggerSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
        setSearchSubject: (state, action: PayloadAction<string>) => {
            state.searchSubject = action.payload;
        },
    }
});

export const MarketingEmailSearchSelector = createSelector(
    (state: RootState) => state.marketingEmailSearch,
    (data) => data
);

export const {
    setMarketingEmailSearchResults,
    setTriggerSearch,
    setSearchResultTotalRecord,
    setOrderBy,
    setOrderDirection,
    setSearchSubject
} = MarketingEmailSearchSlice.actions;

export default MarketingEmailSearchSlice.reducer;